import React from 'react'
import _ from 'lodash'
import URI from 'urijs'
import { navigate } from 'gatsby'
import { useOrderMethod } from '../../vendor/react-omnitech-api'
// import useI18n from '../use-i18n'
import { isUrl } from '../../helpers'
import LinkContext from './link-context'

/**
 * LinkProvider
 * Contain most logic handing navigate
 */
export default function LinkProvider({ value: { locale }, children }) {
  // const { getLocalePath } = useI18n()
  const { orderMethod } = useOrderMethod()

  function getCommerceChannelFromPath(path = '/') {
    const uri = new URI(path)
    const qsObj = uri.search(true)
    return _.get(qsObj, 'cc')
  }

  function getPath(to, { commerceChannel, locale: newLocale, params = {} } = {}) {
    let url = `/${newLocale || locale}/${_.replace(to, /^\//, '')}`
    if (isUrl(to)) {
      // when it is in development mode, will replace the origin of
      url = _.startsWith(to, process.env.GATSBY_WEBSITE_URL) ? removeUrlOrigin(to) : to
    }
    const uri = new URI(url)
    const qsObj = uri.search(true)
    let cc = commerceChannel
    const orderMethodMandatoryPaths = [
      'categories',
      'products',
      'products-all',
      'products-comparison',
      'product',
    ]
    const isPathOrderMethodMandatory = (path) => {
      const regExp = new RegExp(`^/${path}(/|$)`)
      return regExp.test(to)
    }
    if (
      _.isUndefined(cc)
      && _.some(orderMethodMandatoryPaths, isPathOrderMethodMandatory)
    ) {
      cc = _.get(orderMethod, 'commerceChannel')
    }
    return uri
      .search({
        ...qsObj,
        ...params,
        ...(cc ? { cc } : {}),
      })
      .toString()
    // return url
  }

  function removeUrlOrigin(originUrl) {
    const url = URI(originUrl)
    return `${url.path()}${url.search()}`
  }

  function handleNavigate(to, { commerceChannel, locale: newLocale, ...options } = {}) {
    const url = getPath(to, { commerceChannel, locale: newLocale })
    navigate(url, options)
  }

  function handleRecordNotFound(page) {
    const ccFromPath = getCommerceChannelFromPath(page)
    if (
      !_.isEmpty(ccFromPath)
      && ccFromPath !== _.get(orderMethod, 'commerceChannel')
    ) return
    navigate(`/${locale}/404/`, { replace: true, state: { origPage: page } })
  }

  function goBack() {
    navigate(-1)
  }

  const state = {
    getPath,
    goBack,
    navigate: handleNavigate,
    recordNotFound: handleRecordNotFound,
  };

  return (
    <LinkContext.Provider value={state}>
      {children}
    </LinkContext.Provider>
  )
}
